"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

angular.module("pages").controller("CreateBaseController", function (vm, $q, $timeout, $scope, service, listPage, nameModel, params, hotkeys, $state, $stateParams, $rootScope, ModalService) {
  vm.model = {};

  if (!vm.check) {
    vm.check = function () {
      return vm.save();
    };
  }

  console.log("in CreateBaseController");

  setTimeout(function () {
    hotkeys.bindTo($scope).add({
      combo: "enter",
      description: "Valider le formulaire",
      callback: function callback() {
        vm.check();
      }
    });

    hotkeys.bindTo($scope).add({
      combo: "esc",
      description: "Sortir du formulaire",
      callback: function callback() {
        vm.cancel();
      }
    });
  }, 0);

  var _id;

  if ($stateParams._id) {
    _id = $stateParams._id;
  } else if (params._id) {
    _id = params._id;
  }

  if (_id || params.edition) {
    vm.displayTitle = "Modification d'" + nameModel;

    if (service) {
      var promise = service.findById({ _id: _id });

      promise.then(function (value) {
        console.log("model", value);

        if (value) {
          vm.model = angular.copy(value);
          vm.initialModel = angular.copy(vm.model);

          console.log("vm.model in createBaseController", vm.model);
        } else {
          console.log("no model load !!!");
        }

        if (vm.ready) {
          $timeout(vm.ready, 100);
        }
      });
    } else {
      if (vm.ready) {
        $timeout(vm.ready, 100);
      }
    }
  } else {
    console.log("new resource");

    vm.displayTitle = "Création d'" + nameModel;

    vm.initialModel = {};
    vm.model = {};
    vm.model.customerId = $rootScope.$selectedCustomerId;

    if (vm.ready) {
      console.log("call vm.ready");
      $timeout(vm.ready, 100);
    }
  }

  vm.return = function (value) {
    if (params.fromModal) {
      console.log("close modal with value=", value);
      $scope.$close(value);
    } else {
      console.log("go to", listPage);
      $state.go(listPage);
    }
  };

  vm.cancel = function () {
    $scope.$dismiss();
  };

  vm.editDocs = function (row) {
    ModalService.open("gallery/gallery", { docs: vm.model.docs }).then(function (docs) {
      console.log("docs", docs);

      vm.model.docs = docs;
    });
  };

  vm.emitUpdateNotification = function () {
    console.log("emitUpdateNotification for " + service.name);

    $rootScope.$bus.publish({
      channel: service.name,
      topic: "update",
      data: {}
    });
  };

  vm.saveState = function (name, state) {
    localforage.setItem(name, state);
  };

  vm.save = function () {
    Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");

    try {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = Object.keys(vm.model)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          if (vm.model[key] == undefined) {
            vm.model[key] = null;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return $q(function (resolve, reject) {
        var _this = this;

        if (vm.model._id) {
          // Update
          var saveModel = JSON.parse(JSON.stringify(vm.model));

          var _promise = service.customPatch("updateOne", {
            filters: {
              _id: vm.model._id
            },
            vals: saveModel
          });

          _promise.then(function (value) {
            Notiflix.Loading.remove();

            Notiflix.Notify.success("La sauvegarde a réussi");

            vm.return(value);

            vm.emitUpdateNotification();

            resolve(value);
          }).catch(function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(err) {
              return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      Notiflix.Loading.remove();

                      Notiflix.Notify.failure("La sauvegarde a échoué");

                      reject(err);

                    case 3:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, _this);
            }));

            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }());
        } else {
          var _saveModel = JSON.parse(JSON.stringify(vm.model));

          var _promise2 = service.customPost("createOne", _saveModel);

          _promise2.then(function (value) {
            Notiflix.Loading.remove();

            Notiflix.Notify.success("La création a réussi");

            vm.return(value);

            vm.emitUpdateNotification();

            resolve(value);
          }).catch(function (err) {
            Notiflix.Loading.remove();

            if (err.status === 422) {
              Notiflix.Notify.failure("Vérifier la cohérence des champs");
            } else {
              Notiflix.Notify.failure("La création a échoué");
            }

            reject(err);

            console.log(err);
          });
        }
      });
    } catch (error) {
      console.error(error);
    }

    Notiflix.Loading.remove();
  };
});